import {
    ReportTimeInterval, ScheduleType
} from "@shopliftr/common-js/shared";

/**
 * Feature Group ID for Reporting
 * This ID is used to identify the Reporting feature group in the application
 */
export const REPORTING_FEATURE_GROUP_ID = "REPORTING_FEATURE_GROUP";

export const INTERVAL_HOURLY = {
    view: "Hour",
    value: ReportTimeInterval.Hourly,
    baselineType: ScheduleType.Daily
};

export const INTERVALS = [
    {
        view: "Day",
        value: ReportTimeInterval.Daily,
        baselineType: ScheduleType.Daily
    },
    {
        view: "Week",
        value: ReportTimeInterval.Weekly,
        baselineType: ScheduleType.Weekly
    },
    {
        view: "Month",
        value: ReportTimeInterval.Monthly,
        baselineType: ScheduleType.Monthly
    },
    {
        view: "Year",
        value: ReportTimeInterval.Yearly,
        baselineType: ScheduleType.Yearly
    },
    {
        view: "Total",
        value: ReportTimeInterval.Totally,
        baselineType: ScheduleType.Yearly
    }
];
